export function generateContentTemplate({ colorIcon, icon, title, mensagem, hasTimer, actionButton }) {
  return `
    <div class="toast-content">
      <span class="toast-title">
        <svg class="icon fill-${colorIcon}" width="16" height="16">
          <use href="#icon-${icon}"></use>
        </svg>
        <span>${title}</span>
      </span>
      <span class="toast-message">${mensagem}</span>
      ${actionButton ? `
        <a href="${actionButton.href}" class="toast-action-button text-maino-green font-weight-700 mt-1" ${actionButton.target ? `target="${actionButton.target}"` : ''}>
          ${actionButton.label}
        </a>
      ` : ''}
    </div>
    <button type="button" class="close" data-dismiss="alert" aria-label="Close" onclick="close_toast(this)">
      <svg class="icon fill-cinza-5" width="20" height="20"><use href="#icon-x-mark"></use></svg>
    </button>
  `;
}

export function generateProgressBarTemplate(colorIcon) {
  return `
    <div class="progress-bar">
      <div class="progress-bar-inner" style="width: 0%; background-color: var(--${colorIcon});"></div>
    </div>
  `;
}

export function generateToastTemplate({ classe, content, barraProgresso, hasTimer, toastId }) {
  return `
    <div class="maino-toast ${classe}" data-toast-id="${toastId}">
      ${hasTimer
        ? `
          <div class="toast-container">
            ${content}
            ${barraProgresso}
          </div>
        `
        : content
      }
    </div>
  `;
}
